import {
  CertificateTypeEnum,
  ExemptionIdTypeEnum,
  ExemptionReasonEnum,
  ExemptionStatusEnum,
  VerificationStatusEnum,
} from '@commenda/api/new-sales-tax/exemptions/types';

export enum ExpiryPeriodEnum {
  YEAR_END = 'YEAR_END',
  ONE_YEAR = 'ONE_YEAR',
  TWO_YEARS = 'TWO_YEARS',
  THREE_YEARS = 'THREE_YEARS',
  FOUR_YEARS = 'FOUR_YEARS',
  FIVE_YEARS = 'FIVE_YEARS',
}

type CertificateType = `${CertificateTypeEnum}`;
type ExemptionIdType = `${ExemptionIdTypeEnum}`;
type ExemptionStatus = `${ExemptionStatusEnum}`;
type ExemptionReason = `${ExemptionReasonEnum}`;
type ExpiryPeriod = `${ExpiryPeriodEnum}`;
type VerificationStatus = `${VerificationStatusEnum}`;

interface StateExpiryConfig {
  hasExpiry: boolean;
  expiryPeriod?: ExpiryPeriod;
}

export interface TaxExemptionConfigInterface {
  [ExemptionReasonEnum.PURPOSE_RESALE]: Record<string, StateExpiryConfig>;
  [ExemptionReasonEnum.ENTITY_TYPE_NONPROFIT]: Record<
    string,
    StateExpiryConfig
  >;
  [ExemptionReasonEnum.GOVERNMENT]: Record<string, StateExpiryConfig>;
  [ExemptionReasonEnum.MANUFACTURER]: Record<string, StateExpiryConfig>;
  [ExemptionReasonEnum.AGRICULTURAL]: Record<string, StateExpiryConfig>;
  [ExemptionReasonEnum.OTHER]: Record<string, StateExpiryConfig>;
}

export interface CertificateStateConfig {
  [CertificateTypeEnum.MTC]: string[];
  [CertificateTypeEnum.SST]: string[];
  [CertificateTypeEnum.SINGLE_STATE]: string[];
}

interface StateExemption {
  state: string;
  idType?: ExemptionIdType;
  idNumber: string;
  expirationDate?: string;
  exemptionStatus: ExemptionStatus;
  stateExemptionReason?: ExemptionReason;
}

interface ExemptionCertificate {
  customerId: string;
  certificateType: CertificateType;
  states: string[];
  effectiveStartDate: string;
  certificateFileUrl?: string;
  exemptionsForStates: StateExemption[];
}

// Types for UI Components
export interface SelectOption<T extends string> {
  value: T;
  label: string;
}
export enum ExemptionCertificateFormMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  PREVIEW = 'PREVIEW',
}

export enum ExemptCustomerFormMode {
  EDIT = 'EDIT',
  PREVIEW = 'PREVIEW',
}

export type ExemptionCertificateFormModeType =
  `${ExemptionCertificateFormMode}`;

export type ExemptCustomerFormModeType = `${ExemptCustomerFormMode}`;

export enum ExemptionsFormField {
  CUSTOMER = 'customer',
  CERTIFICATE_TYPE = 'certificateType',
  EFFECTIVE_START_DATE = 'effectiveStartDate',
  STATES = 'states',
  CERTIFICATE_FILE = 'certificateFile',
  EXEMPTION_REASON = 'exemptionReason',
  EXPIRY_DATE = 'expiryDate',
  SELLER = 'seller',
}

export type ExemptionsFormFieldType = `${ExemptionsFormField}`;

export enum ExemptCustomerFormField {
  CUSTOMER_ID = 'customerId',
  CUSTOMER_NAME = 'Name',
  EMAIL = 'email',
  COUNTRY = 'country',
  STATE = 'state',
  CITY = 'city',
  ZIP_CODE = 'zipCode',
  ADDRESS_LINE_1 = 'addressLine1',
  ADDRESS_LINE_2 = 'addressLine2',
}

export type ExemptCustomerFormFieldType = `${ExemptCustomerFormField}`;
